import { Badge } from "@/components/ui/badge"
import { cn } from "@/lib/utils"

export interface AssetTrustBadgeProps {
  /** Provenance of the AI label, e.g. "codex_native_subagents", "fireworks_*". */
  labelSource?: string | null
  /** ISO timestamp set when a human reviewed the asset. */
  reviewedAt?: string | null
  /** Review state of the label, e.g. "approved" | "needs_review" | "labeled". */
  labelStatus?: string
  className?: string
}

function isAiLabelSource(labelSource?: string | null): boolean {
  if (!labelSource) return false
  const normalized = labelSource.toLowerCase()
  return normalized.includes("codex") || normalized.includes("fireworks")
}

export function AssetTrustBadge({
  labelSource,
  reviewedAt,
  labelStatus,
  className,
}: AssetTrustBadgeProps) {
  const humanApproved = Boolean(reviewedAt) && labelStatus === "approved"

  if (humanApproved) {
    return (
      <Badge
        title={labelSource ?? undefined}
        className={cn(
          "bg-teal-light text-teal-dark border-teal/20",
          className
        )}
      >
        Human-approved
      </Badge>
    )
  }

  if (isAiLabelSource(labelSource)) {
    return (
      <Badge
        title={labelSource ?? undefined}
        className={cn(
          "bg-muted text-muted-foreground border-transparent",
          className
        )}
      >
        AI-labeled
      </Badge>
    )
  }

  return null
}

export default AssetTrustBadge
